<template>
  <div>
    <b-modal
      v-model="previewDialog"
      size="lg"
      title="Pré-visualização de documento"
      scrollable
    >
      <div v-if="isImage" class="image-container mt-4">
        <img
          :src="fileSrc"
          alt="Pré-visualização da imagem"
          class="preview-image"
        >
      </div>
      <div v-else>
        <div ref="container" class="holds-the-iframe" data-cy="pdf-container">
          <iframe
            id="iframe"
            ref="iframe_preview"
            src=""
            name="iframe_preview"
            style="width: 100%; height: 600px; border: none; margin: 0px"
            type="application/pdf"
          ></iframe>
        </div>
      </div>
      <div v-show="showloading" style="height: 0px" class="wait-loading"></div>
      
      <template #modal-footer>
        <b-button variant="primary" @click="closePreview">Fechar</b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      previewDialog: false,
      fileSrc: null,
      isImage: false,
      showloading: true
    }
  },
  methods: {
    async showPreview(file, fileType) {
      this.previewDialog = true
      this.isImage = false
      this.fileSrc = null
      this.showloading = true

      await this.sleep(50)
      try {
        const binaryString = window.atob(file)
        const len = binaryString.length
        const bytes = new Uint8Array(len)

        for (let i = 0; i < len; i++) {
          bytes[i] = binaryString.charCodeAt(i)
        }

        if (fileType.endsWith('pdf')) {
          const pdfBlob = new Blob([bytes.buffer], { type: fileType })
          const url = URL.createObjectURL(pdfBlob)
          this.$refs.iframe_preview.src = url
        }

        if (fileType.startsWith('image/')) {
          this.isImage = true
          const imagemBlob = new Blob([bytes.buffer], { type: fileType })
          this.fileSrc = URL.createObjectURL(imagemBlob)
          this.$refs.iframe_preview.src = ''
        }

        this.showloading = false
        window.dispatchEvent(new Event('resize'))
      } catch (error) {
        console.error('Erro ao pré-visualizar o documento:', error)
      }
    },
    sleep(ms) {
      return new Promise(resolve => {
        setTimeout(resolve, ms)
      })
    },
    closePreview() {
      this.previewDialog = false
      this.fileSrc = null
      this.$refs.iframe_preview.src = ''
    }
  }
}
</script>

<style scoped>
.image-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 600px;
}

.preview-image {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  display: block;
  margin: auto;
}
</style>
